export const uploadCaseFileFormat = "";
export const uploadPaymentFileFormat = "client_reference_id, payment_received";
export const bulkFieldUpdateFileFormat = "<client_reference_id alias>, <all column you want to update>";
export const uploadAgentAllocationFileFormat = "client_name, client_reference_id, username, expiry_date (date format: YYYYMMDD)";
export const removeAgentAllocationFileFormat = "client_name, client_reference_id, username";
export const pincodeUploadFormat = "pin_code, area_name, district, state_name, latitude, longitude";
export const permissionSetUploadFormat = "permission_name, username, is_active, license_count";
export const uploadFocusedCaseAllocationByClient = "client_reference_id";
export const uploadFocusedCaseAllocationByAgency = "client_reference_id, client_name";
